import e, { forwardRef as r } from "react";
const g = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M4 4H2v16h2v-4h16v4h2v-6H4z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M7.5 13c1.4 0 2.5-1.1 2.5-2.5S8.9 8 7.5 8 5 9.1 5 10.5 6.1 13 7.5 13zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM19.4 7.8H11V13h1.9V9.7h6.5c.4 0 .7.3.7.8V13H22v-2.6c0-1.4-1.2-2.6-2.6-2.6z" })
), p = r(g), d = p, M = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M5.3 17H2.1v1.9h3.3c1.3 0 2.5-.5 3.4-1.3l-1.3-1.3c-.7.4-1.4.7-2.2.7zM10.2 7.3 7.5 10l-.2.2c-.9 1.1-.9 2.7.1 3.7l3.6 3.6c.6.6.9 1.4.9 2.2V22h1.9v-2.3c0-1.3-.5-2.6-1.5-3.5l-3.6-3.6c-.3-.3-.3-.8 0-1.1l2.8-2.8c.5-.5 1.3-.5 1.7 0 .2.2.4.5.4.9s-.1.6-.4.9l-2 2 1.3 1.3 2-2c.6-.6.9-1.4.9-2.2s-.3-1.6-.9-2.2c-1-1.3-3.1-1.3-4.3-.1zM17.5 2C16.1 2 15 3.1 15 4.5S16.1 7 17.5 7 20 5.9 20 4.5 18.9 2 17.5 2zm0 3.3c-.4 0-.8-.4-.8-.8s.4-.8.8-.8.8.4.8.8-.4.8-.8.8z" })
), i = r(M), S = i, z = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M11 3v15l-4.5-4.5-1.4 1.4 5.5 5.5c.4.4.9.6 1.4.6s1-.2 1.4-.6l5.5-5.5-1.4-1.4L13 18V3h-2z" })
), x = r(z), H = x, R = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M21 11H6l4.5-4.5-1.4-1.4-5.5 5.5c-.4.4-.6.9-.6 1.4 0 .5.2 1 .6 1.4l5.5 5.5 1.4-1.4L6 13h15v-2z" })
), C = r(R), L = C, O = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M3 13h15l-4.5 4.5 1.4 1.4 5.5-5.5c.4-.4.6-.9.6-1.4s-.2-1-.6-1.4l-5.5-5.5-1.4 1.4L18 11H3v2z" })
), A = r(O), B = A, T = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M13 21V6l4.5 4.5 1.4-1.4-5.5-5.5C13 3.2 12.5 3 12 3s-1 .2-1.4.6L5.1 9.1l1.4 1.4L11 6v15h2z" })
), V = r(T), F = V, _ = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "m12.379 1.045-.07-.07-.071.07L.929 12.354l-.07.07.07.071.571.571.071.071.07-.07 11.31-11.309.07-.07-.07-.071-.572-.572Z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M13 12.812h.1V.9H1.19v1.008h10.903V12.81H13Z" })
), f = r(_), N = f, $ = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M18.5 2 7.8 12.6l3.5 3.5L22 5.5 18.5 2zm-7.8 10.6 7.8-7.8.7.7-7.8 7.8-.7-.7zM6.4 14.5c-1.8 0-2.7 1.5-3.2 3.1L2 22l4.4-1.2c1.6-.5 3.1-1.4 3.1-3.1 0-1.8-1.4-3.2-3.1-3.2zm-.5 4.4-1.1.3.3-1.1c.3-1.2.8-1.7 1.3-1.8.7 0 1.2.5 1.2 1.3 0 .7-1.1 1.2-1.7 1.3z" })
), u = r($), y = u, U = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M20 10.5c0-.6-.1-1.2-.2-1.7.8-.8 1-2 .4-3-.5-.8-1.3-1.3-2.2-1.3-.2 0-.5 0-.7.1-.8-.8-1.8-1.3-2.9-1.7C14.2 1.8 13.2 1 12 1s-2.2.8-2.4 1.9c-1.1.4-2.1.9-3 1.7-.2-.1-.4-.1-.7-.1-.8 0-1.7.5-2.1 1.3-.6 1-.4 2.3.4 3-.1.5-.2 1.1-.2 1.7 0 .6.1 1.2.2 1.7-.8.8-1 2-.4 3 .5.8 1.3 1.3 2.2 1.3.2 0 .5 0 .7-.1.7.6 1.5 1.1 2.3 1.5l-.6 2.2H4V22h16v-1.9h-4.3l-.6-2.2c.9-.4 1.6-.9 2.3-1.5.2.1.4.1.7.1.9 0 1.7-.4 2.2-1.3.6-1 .4-2.3-.4-3 0-.5.1-1.1.1-1.7zM18.1 6c.4 0 .7.2.9.5.2.5 0 1.1-.4 1.4-.2.1-.4.1-.5.1-.4 0-.7-.2-.9-.5-.3-.5-.1-1.1.4-1.4.1 0 .3-.1.5-.1zM12 2.5c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-6.9 4c.1-.3.5-.5.8-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4-.2.3-.5.5-.9.5-.1 0-.3 0-.5-.1-.4-.3-.6-.9-.3-1.4zm0 8c-.3-.5-.1-1.1.3-1.4.2 0 .4-.1.5-.1.4 0 .7.2.9.5.3.5.1 1.1-.4 1.4-.1.1-.3.1-.5.1-.3 0-.7-.2-.8-.5zm8.6 5.6h-3.5l.5-1.7c.4.1.8.1 1.3.1s.8 0 1.3-.1l.4 1.7zm-2.4-3.5L12 14l.7 2.6h-1.4zm1.6-6.4c-.1-.4-.5-.7-.9-.7s-.8.3-.9.7L9.4 16c-.5-.2-.9-.5-1.3-.8.4-.7.4-1.7 0-2.4-.5-.8-1.3-1.3-2.1-1.3-.1-.3-.1-.7-.1-1 0-.3 0-.7.1-1 .8 0 1.7-.5 2.1-1.2.4-.8.4-1.7 0-2.4.5-.4 1.1-.8 1.7-1 .5.6 1.3 1.1 2.2 1.1.9 0 1.7-.5 2.1-1.2.6.2 1.2.6 1.7 1-.4.7-.4 1.7 0 2.4.5.8 1.4 1.3 2.2 1.3.1.3.1.7.1 1 0 .3 0 .7-.1 1-.8 0-1.7.5-2.1 1.2-.5.8-.4 1.7 0 2.4-.4.3-.8.6-1.3.8l-1.7-5.7zm6 4.3c-.2.3-.5.5-.9.5-.2 0-.3 0-.5-.1-.5-.3-.6-.9-.4-1.4.2-.3.5-.5.9-.5.2 0 .3 0 .5.1.5.3.7.9.4 1.4z" })
), P = r(U), Z = P, D = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M17.9 10.8c.1-.9 0-1.8-.2-2.8-.5-2.6-.8-6-.8-6H7s-.3 3.4-.8 6C6 9 5.9 9.9 6 10.8c.3 2.7 2.5 4.7 5 5.1V20H7v2h10v-2h-4v-4.1c2.4-.4 4.6-2.3 4.9-5.1zM12 4h3.2c.1.9.2 1.9.4 3H8.4c.2-1.1.3-2.1.4-3H12zm-4 6.6c-.1-.5 0-1 0-1.6h7.8c.1.6.1 1.1 0 1.6-.2 2-1.9 3.1-3.4 3.4h-1.1c-1.4-.3-3-1.4-3.3-3.4z" })
), G = r(D), I = G, k = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M5 4h5v1.9H5zM17.6 12c-.1 0-.1 0 0 0l-1.1-5.4c-.1-.2 0-.4.1-.5.1-.1.2-.2.4-.2h3V4h-3c-.8 0-1.5.4-2 1s-.6 1.4-.5 2l.2 1H7.2l-.7 4C4 12 2 14 2 16.5S4 21 6.5 21s4.5-2 4.5-4.5c0-1.8-1.1-3.4-2.7-4.1l.5-2.5h6.3l.5 2.6c-1.5.7-2.6 2.3-2.6 4 0 2.5 2 4.5 4.5 4.5s4.5-2 4.5-4.5-1.9-4.5-4.4-4.5zm-8.4 4.5c0 1.5-1.2 2.7-2.7 2.7S3.8 18 3.8 16.5c0-1.4 1-2.5 2.3-2.7l-.5 3h1.9l.5-2.5c.7.4 1.2 1.3 1.2 2.2zm8.4 2.7c-1.5 0-2.7-1.2-2.7-2.7 0-.9.4-1.7 1.1-2.2l.5 2.5h1.9l-.6-3c1.4.1 2.4 1.3 2.4 2.7.1 1.5-1.1 2.7-2.6 2.7z" })
), b = r(k), Y = b, K = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M5.6 6.2c.9 0 1.6-.7 1.6-1.6S6.5 3 5.6 3C4.7 3 4 3.7 4 4.6s.7 1.6 1.6 1.6zM9.9 6.2c.9 0 1.6-.7 1.6-1.6S10.8 3 9.9 3c-.9 0-1.6.7-1.6 1.6S9 6.2 9.9 6.2zM14.1 6.2c.9 0 1.6-.7 1.6-1.6S15 3 14.1 3s-1.6.7-1.6 1.6.7 1.6 1.6 1.6z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 18.4, cy: 4.6, r: 1.6 }),
  /* @__PURE__ */ e.createElement("path", { d: "M5.6 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM9.9 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6zM14.1 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM18.4 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM20 16V8H4v8h16zm-1.8-6.2v4.4H5.8V9.8h12.4z" })
), j = r(K), q = j, J = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 770 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M404.975-198.944c-32.127 19.292-75.9 55.64-82.19 125.216-5.483 60.644 37.02 117.455 86.545 137.757C238.619 22.203 6.016 116.129.26 294.745c-3.277 47.683 27.406 87.822 54.99 123.907l.032.041c1.284 1.68 2.56 3.35 3.827 5.012 70.754 76.44 184.136 108.056 284.054 79.144 32.211-9.572 63.408-23.482 92.266-41.175-17.978 14.924-32.22 33.263-40.903 54.955-17.468 38.168-2.08 82.524 28.645 108.472 4.454 4.232 9.2 7.987 14.158 11.391-15.295-6.014-29.823-10.147-41.347-12.795-29.737-6.864-75.745-11.284-121.181 12.48-45.436 23.764-51.727 95.056-46.684 129.844 5.043 34.788 39.146 68.224 90.873 84.084 51.726 15.86 107.3 17.16 145.146 0 37.846-17.16 84.582-59.436 68.154-124.124-7.364-28.999-27.286-50.662-50.718-66.587 6.269 2.784 12.523 5.573 18.643 8.555 4.797 2.348 10.518 5.471 16.827 8.914l.002.001.001.001c16.045 8.757 35.893 19.591 54.027 25.04 46.207 12.328 96.077-11.716 138.134-31.992 2.469-1.19 4.912-2.368 7.325-3.524 27.916-14.56 43.304-45.292 50.323-75.296 31.241-169.17-182.454-214.889-303.092-148.579 13.247-9.854 25.831-20.565 37.596-32.069 61.76-58.812 90.457-173.42 70.338-214.552a203.27 203.27 0 0 0-12.581-26.495 89.667 89.667 0 0 1 1.508 2.419c2.406 3.99 4.469 8.179 6.531 12.369l.001.001c2.749 5.586 5.499 11.172 9.064 16.282a45.394 45.394 0 0 0 4.939 6.032 51.623 51.623 0 0 0 16.583 11.492c2.652 1.144 5.355 2.132 8.058 3.12.431.159.86.318 1.288.478 2.106.783 4.194 1.561 6.354 2.122 2.252.58 4.523 1.059 6.79 1.538 1.397.295 2.792.589 4.179.906a168.297 168.297 0 0 0 38.158 4.212c6.603 0 13.205-.416 19.755-1.248a105.529 105.529 0 0 0 9.826-1.872c.179-.039.36-.078.542-.115l.356-.073c1.129-.23 2.276-.463 3.261-.956 1.039-.572 2.131-.988 3.275-1.352a96.568 96.568 0 0 0 16.843-6.76c4.055-2.08 7.954-4.368 11.749-6.968a100.253 100.253 0 0 0 23.498-21.944c1.716-2.236 3.275-4.576 4.731-6.968 6.706-11.284 10.605-23.972 11.437-37.076.52-7.852.104-16.068-2.131-23.608a185.086 185.086 0 0 0-2.496-7.592 133.319 133.319 0 0 0-4.782-11.284 98.832 98.832 0 0 0-1.664-3.328c-4.939-9.464-11.073-18.252-18.195-26.208a123.18 123.18 0 0 0-24.174-20.8c-4.471-2.912-9.098-5.564-13.932-7.852-1.43-.682-2.844-1.395-4.259-2.108-3.113-1.57-6.229-3.14-9.518-4.392-5.926-2.236-12.009-3.9-18.299-4.94-3.015-.468-6.03-.832-9.046-1.04-1.403-.156-2.755-.208-4.159-.104-.332.024-.654.091-.969.157h-.001c-.375.079-.742.155-1.109.155-1.04-.052-2.132-.156-3.171-.364-4.419-.416-8.89 0-13.205 1.248a49.597 49.597 0 0 0-5.683 1.901 135.417 135.417 0 0 0 7.919-6.113c53.13-44.304 35.403-144.196 15.18-177.112s-96.903-84.76-155.96-75.92c-59.057 8.84-72.521 12.896-93.212 25.324Zm136.406 342.201c-27.576-34.362-65.609-58.24-108.845-72.566 49.006 8.31 124.229 4.145 178.334-23.595-1.293.973-2.579 1.956-3.865 2.939-5.762 4.404-11.521 8.807-17.894 12.27-4.745 2.582-9.749 4.58-14.743 6.573l-.004.002h-.001c-2.444.976-4.886 1.95-7.294 2.992-7.33 3.172-14.66 7.02-20.171 12.844-6.966 7.384-11.073 17.68-11.853 27.768a39.72 39.72 0 0 0 .208 8.944c.052.572.104 1.144.104 1.716.052 1.3.156 2.6.312 3.9.208 1.768.572 3.484 1.04 5.2.52 1.612 1.092 3.224 1.82 4.784a59.694 59.694 0 0 0 2.852 6.229Z"
    }
  )
), Q = r(J), X = Q, W = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ e.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M18 2H6C3.8 2 2 3.8 2 6v16h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2V6c0-2.2-1.8-4-4-4zm0 8H6c-.7 0-1.4.2-2 .6V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.6c-.6-.4-1.3-.6-2-.6z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M9.5 5.2h5V7h-5z" })
), e1 = r(W), t1 = e1, c1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 7, cy: 15, r: 1 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17, cy: 15, r: 1 }),
  /* @__PURE__ */ e.createElement("path", { d: "M6 18.1h12v1.8H6z" }),
  /* @__PURE__ */ e.createElement("path", { d: "m19.9 10.5-.6-4.1c-.3-2-2-3.4-4-3.4H8.6c-2 0-3.7 1.5-4 3.4L4 10.5c-1.2.7-2 2-2 3.5v8h2v-8c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8h2v-8c0-1.5-.8-2.8-2.1-3.5zM8.6 5h6.8c1 0 1.8.7 2 1.7l.5 3.3H6.2l.5-3.3c.1-1 .9-1.7 1.9-1.7z" })
), r1 = r(c1), l1 = r1, n1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      className: "Check_svg__st0",
      d: "M10 18c-.2 0-.5-.1-.7-.3l-6-5.4 1.3-1.5 5.3 4.8 10.4-9.4 1.3 1.5-11 10c-.2.2-.4.3-.6.3z"
    }
  )
), h1 = r(n1), a1 = h1, s1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M19.7 9.7 12 17.4 4.3 9.7l1.4-1.4 6.3 6.3 6.3-6.3z" })
), m1 = r(s1), o1 = m1, v1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M14.3 19.7 6.6 12l7.7-7.7 1.4 1.4L9.4 12l6.3 6.3z" })
), w1 = r(v1), E1 = w1, g1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "m9.7 4.3 7.7 7.7-7.7 7.7-1.4-1.4 6.3-6.3-6.3-6.3z" })
), p1 = r(g1), d1 = p1, M1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M4.3 14.3 12 6.6l7.7 7.7-1.4 1.4L12 9.4l-6.3 6.3z" })
), i1 = r(M1), S1 = i1, z1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M10.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM2 3h9v2H2zM5.9 8.4c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6 1.6-.8 1.6-1.6zM21.3 8.4c0-.9-.8-1.6-1.6-1.6-.9 0-1.6.8-1.6 1.6 0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM13 3h9v2h-9zM16.9 8.4c0-.9-.8-1.6-1.6-1.6s-1.6.8-1.6 1.6c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6zM8.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM2 14h9v2H2zM4.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM19.7 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zM13 14h9v2h-9zM15.3 17.8c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6z" })
), x1 = r(z1), H1 = x1, R1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M13 6h-2v7h6v-2h-4z" })
), C1 = r(R1), L1 = C1, O1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M21 4.4 19.6 3 12 10.6 4.4 3 3 4.4l7.6 7.6L3 19.6 4.4 21l7.6-7.6 7.6 7.6 1.4-1.4-7.6-7.6z" })
), A1 = r(O1), B1 = A1, T1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M10.3 7c1.8 0 3.5 1.1 3.9 3.2h2.5c1.8 0 3.4 1.5 3.4 3.4S18.6 17 16.7 17H6.5C5.2 17 4 15.8 4 14.2c0-1.2 1.1-2.5 2.5-2.6C6.1 8.5 8.1 7 10.3 7m0-2c-1.8 0-3.4.7-4.5 1.9-.6.7-1.2 1.7-1.4 3.3C3 11 2 12.6 2 14.2 2 16.8 4 19 6.5 19h10.2c3 0 5.4-2.4 5.4-5.4s-2.4-5.4-5.4-5.4h-1c-1.1-2-3.1-3.2-5.4-3.2z" })
), V1 = r(T1), F1 = V1, _1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M3 18h6.3v2H3z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M21 15.6V4H3v11.7h8V20h10v-2h-8v-2.4h8zm-3.4-9.7-3.9 3.5c-.9.8-2.4.8-3.3 0l-4-3.5h11.2zM4.9 7l4.3 3.7c.8.7 1.8 1 2.8 1s2.1-.3 2.8-1L19.1 7v6.8H4.9V7z" })
), f1 = r(_1), N1 = f1, $1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M24 0v24H0V0" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M19.5 2h-10C8.7 2 8 2.7 8 3.5V7H4.5C3.7 7 3 7.7 3 8.5v12c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5V17h3.5c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5zM14 20H5V9h9v11zm5-5h-3V8.5c0-.8-.7-1.5-1.5-1.5H10V4h9v11z" })
), u1 = r($1), y1 = u1, U1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M20 9v8c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9H2v8c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V9h-2z" }),
  /* @__PURE__ */ e.createElement("path", { d: "m16.7 11.7-1.4-1.4-2.3 2.4V2h-2v10.7l-2.3-2.4-1.4 1.4 4.7 4.6z" })
), P1 = r(U1), Z1 = P1, D1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 18",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ e.createElement("path", { d: "M21.6471 11.7391L9.54924 11.7391M0.647064 11.7391H3.15793", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("circle", { cx: "6.58184", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("circle", { cx: "16.1688", cy: "3.52174", r: "2.23913", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M19.3645 10.3696L19.8636 10.3402C19.8642 10.35 19.8645 10.3598 19.8645 10.3696L19.3645 10.3696ZM18.8653 10.3989C18.7694 8.76773 17.5494 7.96774 16.3128 7.97109C15.6918 7.97278 15.0946 8.18101 14.659 8.57219C14.232 8.95555 13.9297 9.54104 13.9297 10.3696L12.9297 10.3696C12.9297 9.27368 13.3407 8.41192 13.9908 7.82813C14.6323 7.25217 15.476 6.97336 16.3101 6.9711C17.9839 6.96655 19.7313 8.09097 19.8636 10.3402L18.8653 10.3989ZM19.8645 10.3696L19.8645 11.0544L18.8645 11.0544L18.8645 10.3696L19.8645 10.3696ZM13.9297 10.3696L13.9297 11.0543L12.9297 11.0543L12.9297 10.3696L13.9297 10.3696Z", fill: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M9.77749 10.3695L10.2766 10.3402C10.2772 10.35 10.2775 10.3597 10.2775 10.3695L9.77749 10.3695ZM9.27836 10.3989C9.1824 8.7677 7.96244 7.9677 6.72586 7.97106C6.10478 7.97275 5.50764 8.18097 5.07198 8.57216C4.64503 8.95552 4.34271 9.54101 4.34271 10.3695L3.34271 10.3695C3.34271 9.27365 3.7537 8.41189 4.40387 7.8281C5.04531 7.25214 5.88907 6.97333 6.72315 6.97107C8.3969 6.96652 10.1443 8.09094 10.2766 10.3402L9.27836 10.3989ZM10.2775 10.3695L10.2775 17.2174L9.27749 17.2174L9.27749 10.3695L10.2775 10.3695ZM4.34271 10.3695L4.34271 17.2174L3.34271 17.2174L3.34271 10.3695L4.34271 10.3695Z", fill: "currentColor" })
), G1 = r(D1), I1 = G1, k1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 16",
    xmlSpace: "preserve",
    ref: c,
    ...t,
    fill: "none"
  },
  /* @__PURE__ */ e.createElement("path", { d: "M2.82352 16L2.82352 11.2737L2.82352 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M18.8235 16L18.8235 11.2737L18.8235 10.8235", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M13.6471 8L14.1462 7.97064C14.1468 7.98041 14.1471 7.99021 14.1471 8L13.6471 8ZM13.1479 8.02936C13.0485 6.33838 11.7828 5.50874 10.5014 5.51222C9.85786 5.51396 9.23852 5.72969 8.78627 6.13578C8.34273 6.53403 8.02942 7.14183 8.02942 8L7.02942 8C7.02942 6.87446 7.4514 5.9904 8.11816 5.39171C8.7762 4.80086 9.64215 4.51455 10.4986 4.51222C12.2172 4.50755 14.0104 5.66162 14.1462 7.97064L13.1479 8.02936ZM14.1471 8L14.1471 8.70588L13.1471 8.70588L13.1471 8L14.1471 8ZM8.02942 8L8.02942 8.70588L7.02942 8.70588L7.02942 8L8.02942 8Z", fill: "currentColor" }),
  /* @__PURE__ */ e.createElement("circle", { cx: "3.76469", cy: "2.82353", r: "2.32353", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M0.941162 8.70588L0.941162 8C0.941162 5.97741 2.46997 4.90551 3.99999 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("circle", { cx: "2.82353", cy: "2.82353", r: "2.32353", transform: "matrix(-1 0 0 1 20.2353 0)", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M20.2353 8.70588L20.2353 8C20.2353 5.97741 18.7065 4.90551 17.1765 4.94118", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("path", { d: "M21.6471 10.3529L1.88236 10.3529H5.30481e-06", stroke: "currentColor" }),
  /* @__PURE__ */ e.createElement("circle", { cx: "10.3529", cy: "2.82353", r: "2.32353", stroke: "currentColor" })
), b1 = r(k1), Y1 = b1, K1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12.1 15.2c-1 0-1.9-.5-2.2-1.4h2.9v-1.4H7.7c0 2.9 1.7 4.6 4.4 4.6 2.3 0 3.9-1.5 4.2-3.8l-2.1-.2c-.1 1.3-.9 2.2-2.1 2.2zM12.1 7c-2.6 0-4.3 1.8-4.4 4.6h5.2v-1.4h-3c.3-.8 1.2-1.4 2.2-1.4 1.2 0 2 .8 2.1 2.1l2.1-.2C16 8.4 14.3 7 12.1 7z" })
), j1 = r(K1), q1 = j1, J1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M16.6 4V2h-1.9v2H9V2H7v2H2v18h20V4h-5.4zM20 20H4V6h3v2h2V6h5.7v2h1.9V6H20v14z" })
), Q1 = r(J1), X1 = Q1, W1 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M21.3 10c-1-1.3-2.3-2.4-3.7-3.3C16 5.7 14 5 11.9 5c-2 0-3.9.7-5.5 1.8-1.4.9-2.7 2-3.7 3.2-.5.6-.7 1.3-.7 2s.2 1.4.7 2c1.1 1.4 2.4 2.5 3.9 3.5 1.6 1 3.5 1.6 5.4 1.6s3.8-.5 5.4-1.6c1.5-.9 2.8-2.1 3.9-3.5.5-.6.7-1.2.7-2 0-.7-.3-1.4-.7-2zm-1.6 2.7c-.9 1.2-2.1 2.2-3.4 3-1.3.9-2.8 1.3-4.3 1.3s-3-.4-4.3-1.3c-1.3-.8-2.5-1.8-3.4-3-.2-.2-.3-.4-.3-.7 0-.2.1-.5.3-.7.9-1.1 2-2.1 3.2-2.9C8.8 7.5 10.3 7 11.9 7c1.6 0 3.3.5 4.6 1.4 1.2.8 2.3 1.7 3.2 2.9.2.2.3.4.3.7s-.1.5-.3.7z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 8.8c-1.8 0-3.2 1.5-3.2 3.2s1.5 3.2 3.2 3.2 3.2-1.5 3.2-3.2-1.4-3.2-3.2-3.2zm0 4.6c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4z" })
), e2 = r(W1), t2 = e2, c2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M6.5 10.6C7.9 10.6 9 9.5 9 8.1S7.9 5.6 6.5 5.6 4 6.7 4 8.1s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM17.5 7C18.9 7 20 5.9 20 4.5S18.9 2 17.5 2 15 3.1 15 4.5 16.1 7 17.5 7zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM22 11.7c0-2.1-1.8-3.8-3.9-3.8h-1.2c-2.2 0-3.9 1.8-3.9 3.9V14c0 .6-.4 1-1 1-.5 0-.7-.2-1.2-1.1-.2-.3-.3-.6-.5-.8-.7-1-1.9-1.6-3.1-1.6H5.9c-2.2 0-3.9 1.8-3.9 3.9V22h2v-6.6c0-1.1.9-1.9 1.9-1.9h1.2c.6 0 1.2.3 1.5.8.2.2.3.4.4.7.5.9 1.2 2 3 2 1.7 0 3-1.3 3-3v-2.2c0-1.1.9-1.9 1.9-1.9h1.2c1 0 1.9.8 1.9 1.8V22h2V11.7z" })
), r2 = r(c2), l2 = r2, n2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M22 11h-3V7.5C19 5.6 17.4 4 15.5 4H13V2h-2v2H8.5C6.6 4 5 5.6 5 7.5V11H2l3 9H2v2h20v-2h-3l3-9zM7 7.5C7 6.7 7.7 6 8.5 6h7c.8 0 1.5.7 1.5 1.5V11H7V7.5zM7.1 20l-2.3-7h14.4l-2.3 7H7.1z" })
), h2 = r(n2), a2 = h2, s2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M10.8 4C10.4 2.8 9.3 2 8 2s-2.4.8-2.8 2H2v2h3.2C5.6 7.2 6.7 8 8 8s2.4-.8 2.8-2H22V4H10.8zM8 6.2c-.7 0-1.2-.5-1.2-1.2S7.3 3.8 8 3.8s1.2.5 1.2 1.2S8.7 6.2 8 6.2zM8 16c-1.3 0-2.4.8-2.8 2H2v2h3.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2H10.8c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zM16 9c-1.3 0-2.4.8-2.8 2H2v2h11.2c.4 1.2 1.5 2 2.8 2s2.4-.8 2.8-2H22v-2h-3.2c-.4-1.2-1.5-2-2.8-2zm0 4.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z" })
), m2 = r(s2), o2 = m2, v2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M10 6.8c0 1.7-.7 2.1-1.6 2.2V2h-2v7C5.6 8.9 5 8.5 5 6.8V2H3v4.8c0 3.5 2.1 4.1 3.5 4.2v11h2V11c1.4 0 3.5-.7 3.5-4.2V2h-2v4.8zM16.7 2H15v20h2V4c1.3.1 2 .9 2 2.3v9.2h2V6.3C21 3.7 19.3 2 16.7 2z" })
), w2 = r(v2), E2 = w2, g2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm6.9 6h-3.3c-.2-1.4-.6-2.6-1-3.6 1.8.7 3.4 2 4.3 3.6zM14 12c0 .7 0 1.4-.1 2h-3.8c-.1-.6-.1-1.3-.1-2s0-1.4.1-2h3.8c.1.6.1 1.3.1 2zm-3.6 4h3.2c-.4 2.2-1.2 3.6-1.6 3.9-.4-.3-1.2-1.7-1.6-3.9zm0-8c.4-2.2 1.2-3.6 1.6-4 .4.3 1.2 1.7 1.6 4h-3.2zm-1-3.6c-.4 1-.8 2.2-1 3.6H5.1C6 6.4 7.6 5.1 9.4 4.4zM4.3 10h3.8c-.1.6-.1 1.3-.1 2s0 1.4.1 2H4.3c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2zm.8 6h3.3c.2 1.4.6 2.6 1 3.6-1.8-.7-3.4-2-4.3-3.6zm9.5 3.6c.4-1 .8-2.2 1-3.6h3.3c-.9 1.6-2.5 2.9-4.3 3.6zm5.1-5.6h-3.8c.1-.6.1-1.3.1-2s0-1.4-.1-2h3.8c.2.6.3 1.3.3 2s-.1 1.4-.3 2z" })
), p2 = r(g2), d2 = p2, M2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M18.1 12.8h-.5c.4.6.7 1.3.8 2 .9.1 1.6.9 1.6 1.9V20h2v-3.3c0-2.1-1.8-3.9-3.9-3.9zM2 16.7V20h2v-3.3c0-.9.7-1.7 1.6-1.9.1-.7.4-1.4.8-2h-.5c-2.1 0-3.9 1.8-3.9 3.9zM16.9 15.8c0-2.4-1.7-3.9-3.8-3.9H11c-2.2 0-3.9 1.8-3.9 3.9V20h2v-4.2c0-1.1.9-1.9 1.9-1.9h2c1 0 1.9.8 1.9 1.9V20h2v-4.2zM12 10c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm0-4.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3.6-1.3 1.3-1.3zM18.5 11.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5S16 7.8 16 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.4-.8-.8.4-.8.8-.8zM5.5 11.7c1.4 0 2.5-1.1 2.5-2.5S6.9 6.7 5.5 6.7 3 7.8 3 9.2s1.1 2.5 2.5 2.5zm0-3.3c.4 0 .8.4.8.8s-.4.8-.8.8-.8-.3-.8-.8.4-.8.8-.8z" })
), i2 = r(M2), S2 = i2, z2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M13 2H0V0h13v2ZM13 16H0v-2h13v2ZM0 9h20V7H0v2Z" })
), x2 = r(z2), H2 = x2, R2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M16.2 4C18.5 4 20 5.6 20 8c0 3.5-3.1 6.7-7.5 10.8l-.5.4-.5-.5C7.1 14.7 4 11.5 4 8c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7c.7-.7 1.5-1 2.4-1m0-2c-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), C2 = r(R2), L2 = C2, O2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M16.2 2c-1.4 0-2.7.5-3.7 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 2.5 9.2 2 7.8 2 4.4 2 2 4.5 2 8c0 4.5 3.7 8.1 8.2 12.2L12 22l1.8-1.8C18.3 16.1 22 12.5 22 8c0-3.5-2.4-6-5.8-6z" })
), A2 = r(O2), B2 = A2, T2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12.2 14.1C8.6 13.2 7 11.5 7 8.4V2H5v6.4c0 2.3.7 4 2.1 5.3V22h2v-6.9c.8.4 1.6.7 2.7.9 3.4.8 4.2 1.3 4.2 4v2h2v-2c0-4.3-2.3-5.1-5.8-5.9z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12.6 12c2.1 0 3.9-1.7 3.9-3.9s-1.7-3.9-3.9-3.9c-2.1 0-3.9 1.7-3.9 3.9s1.7 3.9 3.9 3.9zm0-5.8c1 0 1.9.8 1.9 1.9 0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9 0-1 .8-1.9 1.9-1.9z" })
), V2 = r(T2), F2 = V2, _2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M11 11h2v7h-2z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 7.5, r: 1.2 }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z" })
), f2 = r(_2), N2 = f2, $2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M14 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1h4z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M7.9 16v-1c0-2.3 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1v1H18v-1c0-3.3-2.7-6-6-6s-6 2.7-6 6v1h1.9z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M3.9 16v-1c0-4.5 3.6-8.1 8.1-8.1s8.1 3.6 8.1 8.1v1H22v-1c0-5.5-4.5-10-10-10S2 9.5 2 15v1h1.9z" })
), u2 = r($2), y2 = u2, U2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M9 4h13v2H9zM9 18h13v2H9zM9 11h13v2H9zM4.5 2.5C3.1 2.5 2 3.6 2 5s1.1 2.5 2.5 2.5S7 6.4 7 5 5.9 2.5 4.5 2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 16.5C3.1 16.5 2 17.6 2 19s1.1 2.5 2.5 2.5S7 20.4 7 19s-1.1-2.5-2.5-2.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zM4.5 9.5C3.1 9.5 2 10.6 2 12s1.1 2.5 2.5 2.5S7 13.4 7 12 5.9 9.5 4.5 9.5zm0 3.2c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7z" })
), P2 = r(U2), Z2 = P2, D2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 10.5, r: 3 }),
  /* @__PURE__ */ e.createElement("path", { d: "M18.5 3.7C16.7 1.9 14.4 1 12 1c-2.4 0-4.7.9-6.5 2.7-1.8 1.8-2.7 4.1-2.7 6.4 0 2.3.9 4.7 2.7 6.4L12 23l6.5-6.5c1.8-1.8 2.7-4.1 2.7-6.4 0-2.3-.9-4.7-2.7-6.4zm-1.4 11.4L12 20.2l-5.1-5.1c-1.3-1.3-2.1-3.1-2.1-5s.7-3.7 2.1-5C8.3 3.7 10.1 3 12 3c1.9 0 3.7.7 5.1 2.1 1.3 1.3 2.1 3.1 2.1 5s-.8 3.7-2.1 5z" })
), G2 = r(D2), I2 = G2, k2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M16.7 3.7c-1.1.3-1.8.3-2.6.1L10 2.4c-.9-.3-1.8-.3-2.8-.1L2 3.3v18.1l5.6-1.1c.6-.1 1.2-.1 1.8.1l4.1 1.4c.5.2 1 .2 1.5.2.6 0 1.4-.1 2.2-.3l4.8-1.5V2l-5.3 1.7zM7.2 18.4l-3.3.7V4.9l3.7-.7c.2 0 .3-.1.5-.1v14.3c-.3-.1-.6 0-.9 0zm2.9.2h-.2V4.4l3.6 1.2c.2.1.4.1.6.2V20l-4-1.4zm10 .2-3.4 1.1c-.3.1-.5.1-.8.2V5.8c.4-.1.9-.2 1.3-.3l2.9-.9v14.2z" })
), b2 = r(k2), Y2 = b2, K2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M2 4h13v2H2zM2 18h13v2H2zM2 11h20v2H2z" })
), j2 = r(K2), q2 = j2, J2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M2 11h20v2H2z" })
), Q2 = r(J2), X2 = Q2, W2 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M6 3h12v2H6zM4 7h16v2H4zM6 19h12v2H6zM2 11h20v2H2zM4 15h16v2H4z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })
), ee = r(W2), te = ee, ce = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M6.6 6v.9c0 5.8 4.7 10.5 10.4 10.5.4 0 .7 0 1.1-.1-1.5 1.7-3.6 2.8-6 2.8-4.4 0-8.2-3.7-8.2-8.1 0-2.4 1.1-4.5 2.7-6M10 2.1c-4.5 1-8.1 5-8.1 9.9 0 5.6 4.7 10.1 10.2 10.1 4.9 0 8.9-3.5 9.8-8.4-1.4 1-3.1 1.6-4.9 1.6-4.6 0-8.4-3.8-8.4-8.5 0-1.7.5-3.4 1.4-4.7z" })
), re = r(ce), le = re, ne = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M2 20h20v2H2zM7.6 15.8c.7 0 1.5-.2 2.2-.5l9.8-4.1c1.5-.6 2.3-1.8 2.3-3.1 0-1-.4-1.8-1.2-2.3-.9-.6-2.2-.7-3.5-.2L14.3 7l-3.4-3c-1.1-1-2.3-1.2-3.5-.7l-2.1.9 2.3 5.6L4.7 11l-.9-2-1.8.8 1.2 2.9c.9 2 2.5 3.1 4.4 3.1zm2.6-5L7.9 5.2l.3-.1c.3-.1.8-.2 1.4.3l4.3 3.9 4.2-1.8c.6-.2 1.2-.2 1.6 0 .2.2.3.4.3.7 0 .7-.8 1.1-1.1 1.2l-9.8 4.1c-1.5.6-2.7.3-3.5-.8l4.6-1.9z" })
), he = r(ne), ae = he, se = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M22 11h-9V2h-2v9H2v2h9v9h2v-9h9z" })
), me = r(se), oe = me, ve = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 2C7 2 2 5.3 2 12h1.7c.4-1.1 1.3-1.7 2.2-1.7s1.7.6 2.1 1.7h1.7c.4-1.1 1.4-1.7 2.3-1.7s1.9.6 2.3 1.7H16c.4-1.1 1.3-1.7 2.2-1.7.9 0 1.8.6 2.1 1.7H22c0-6.7-5-10-10-10zm6.2 6.4c-1.2 0-2.3.5-3.1 1.4A4.1 4.1 0 0 0 12 8.4c-1.2 0-2.3.5-3.1 1.4a4.1 4.1 0 0 0-3.1-1.4c-.5 0-.9.1-1.3.2C5.8 5.4 9 3.9 12 3.9c3.1 0 6.2 1.5 7.5 4.7-.4-.1-.8-.2-1.3-.2zM11 19.4c0 .4-.3.7-.7.7s-.7-.3-.7-.7v-1H7.7v1c0 1.5 1.2 2.6 2.6 2.6s2.6-1.2 2.6-2.6V12H11v7.4z" })
), we = r(ve), Ee = we, ge = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      style: {
        fill: "none"
      },
      d: "M0 0h24v24H0z"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M2 15h2v7H2zM20.7 16.5l-2.9 2.4c-.9.7-2.2 1.2-3.4 1.2H8v-3h7c.6 0 1-.4 1-1s-.4-1-1-1H6V22h8.4c1.8 0 3.5-.6 4.7-1.6L22 18l-1.3-1.5zM11.1 7.6V13h4.7v-1.8h-2.9V7.6c.4-.1.8-.4 1.1-.7.5-.5.8-1.3.8-2 0-.4-.1-.8-.2-1.1-.1-.4-.4-.7-.6-.9-.3-.3-.6-.5-.9-.6-.3-.1-.7-.2-1-.2H12c-.4 0-.7.1-1.1.2-.4.1-.7.4-.9.6-.3.2-.5.5-.7.9-.1.3-.2.7-.2 1.1 0 .8.3 1.5.8 2 .4.3.8.5 1.2.7zm-.2-3.2c.1-.1.1-.3.3-.4.1-.1.2-.2.4-.2.1-.1.3-.1.4-.1.1 0 .3 0 .4.1.1.1.3.1.4.2.1.1.2.2.2.4.1.1.1.3.1.5 0 .3-.1.6-.3.8-.2.2-.5.3-.8.4-.3 0-.6-.1-.8-.4-.2-.2-.3-.5-.3-.9-.1-.1 0-.3 0-.4z" })
), pe = r(ge), de = pe, Me = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M12 1.7 2 10.6V22h2V11.4l8-7.1 8 7.1V22h2V10.6z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M13.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H13c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM9.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-2c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1h2c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9zM17.1 16c0-.1-.1-.2-.1-.3-.2-.5-.4-1-.4-1.8 0-.7.2-1.3.5-1.9h-1.9c-.3.6-.5 1.2-.5 1.9 0 .9.2 1.3.4 1.8 0 .1.1.2.1.3.2.6.3 1.2.3 1.9 0 1-.2 1.6-.4 2.1H17c.2-.5.4-1.2.4-2.1 0-.7-.1-1.3-.3-1.9z" })
), ie = r(Me), Se = ie, ze = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M9.5 2C5.3 2 2 5.3 2 9.5S5.3 17 9.5 17 17 13.7 17 9.5 13.7 2 9.5 2zm0 13C6.4 15 4 12.6 4 9.5S6.4 4 9.5 4c1.5 0 2.9.6 3.9 1.6S15 8 15 9.5c0 3.1-2.4 5.5-5.5 5.5zM15.78 17.215l1.415-1.414 4.738 4.737-1.415 1.415z" })
), xe = r(ze), He = xe, Re = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M20 10v7c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3v-7H2v7c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5v-7h-2z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M11 5.6v9.8h2V5.6L15.3 8l1.4-1.3L12 2 7.3 6.7 8.7 8z" })
), Ce = r(Re), Le = Ce, Oe = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M16.6 7v-.2c0-2.6-2.1-4.8-4.8-4.8C9.2 2.1 7 4.2 7 6.8V7H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7h-5.4zM9 6.8C9 5.2 10.2 4 11.8 4s2.9 1.3 2.9 2.9V7H9v-.2zM20 17c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V9h3v2h2V9h5.7v2h1.9V9H20v8z" })
), Ae = r(Oe), Be = Ae, Te = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "m16.7 6-1.2-3h-7L7.3 6H2v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V6h-5.3zM20 16c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V8H8.7l.5-1.3.7-1.7h4.3l.7 1.7.4 1.3H20v8z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 9c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.1c-1.2 0-2.1-.9-2.1-2.1s.9-2.1 2.1-2.1 2.1.9 2.1 2.1-.9 2.1-2.1 2.1z" })
), Ve = r(Te), Fe = Ve, _e = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M22 11.1h-4.4l2.8-2.9-1.3-1.3-4.2 4.2H13v-2l4.1-4.2-1.3-1.3L13 6.4V2h-2v4.4L8.2 3.6 6.9 4.9 11 9.1v2H9.1L4.9 6.9 3.6 8.2l2.8 2.9H2V13h4.4l-2.8 2.8 1.3 1.3L9.1 13H11v1.9l-4.1 4.2 1.3 1.3 2.8-2.8V22h2v-4.4l2.8 2.8 1.3-1.3-4.1-4.2V13h1.9l4.2 4.1 1.3-1.3-2.8-2.8H22z" })
), fe = r(_e), Ne = fe, $e = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M20.44 10.238a9.656 9.656 0 0 0-1.632-.178c-1.173 0-1.25.51-1.25 1.326v1.453h2.933l-.256 3.009h-2.677V25h-3.671v-9.152H12v-3.01h1.887v-1.86c0-2.55 1.198-3.978 4.207-3.978 1.045 0 1.81.153 2.804.357l-.458 2.881Z"
    }
  )
), ue = r($e), ye = ue, Ue = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.005 10.864a5.14 5.14 0 0 0-5.14 5.138 5.14 5.14 0 0 0 10.28 0 5.14 5.14 0 0 0-5.14-5.138Zm0 8.47a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.668Z"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M21.348 11.86a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M16.006 6c-2.717 0-3.057.012-4.124.059-1.063.046-1.794.218-2.427.465-.66.257-1.22.597-1.774 1.156a4.9 4.9 0 0 0-1.157 1.77c-.246.637-.418 1.363-.465 2.426-.047 1.07-.059 1.41-.059 4.126 0 2.715.012 3.055.059 4.122.047 1.063.219 1.793.465 2.426.258.66.598 1.22 1.157 1.774a4.892 4.892 0 0 0 1.77 1.152c.637.247 1.364.419 2.427.465 1.067.047 1.408.059 4.124.059 2.716 0 3.056-.012 4.123-.059 1.064-.046 1.794-.218 2.428-.464a4.892 4.892 0 0 0 1.77-1.153 4.889 4.889 0 0 0 1.153-1.77c.247-.637.419-1.363.465-2.426.047-1.067.059-1.407.059-4.122 0-2.716-.012-3.055-.059-4.122-.046-1.063-.218-1.793-.465-2.426a4.685 4.685 0 0 0-1.145-1.778 4.892 4.892 0 0 0-1.77-1.153c-.638-.246-1.365-.418-2.428-.464-1.07-.051-1.41-.063-4.127-.063Zm0 1.801c2.673 0 2.99.012 4.041.059.977.043 1.505.207 1.857.344.465.18.801.398 1.149.746.352.351.567.684.746 1.149.137.351.302.882.344 1.855.047 1.055.06 1.372.06 4.04 0 2.672-.013 2.989-.06 4.04-.043.977-.207 1.504-.344 1.856-.18.465-.398.8-.746 1.148a3.078 3.078 0 0 1-1.15.747c-.35.137-.883.3-1.856.343-1.055.047-1.372.06-4.041.06-2.674 0-2.99-.013-4.042-.06-.977-.042-1.504-.206-1.856-.343a3.094 3.094 0 0 1-1.15-.747 3.076 3.076 0 0 1-.746-1.148c-.137-.352-.3-.883-.344-1.856-.047-1.055-.058-1.371-.058-4.04 0-2.672.011-2.989.058-4.04.043-.977.207-1.504.344-1.856.18-.464.399-.8.747-1.148a3.078 3.078 0 0 1 1.149-.746c.352-.137.883-.301 1.856-.344 1.052-.047 1.368-.059 4.042-.059Z"
    }
  )
), Pe = r(Ue), Ze = Pe, De = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M24.5 6h-17C6.7 6 6 6.6 6 7.4v17.1c0 .9.7 1.5 1.5 1.5h17c.8 0 1.5-.6 1.5-1.4V7.4c0-.8-.7-1.4-1.5-1.4zM11.9 23H9v-9.5h3V23zm-1.5-10.8c-1 0-1.7-.8-1.7-1.7 0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7.1.9-.7 1.7-1.7 1.7zM23 23h-3v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.5V23h-3v-9.5h2.8v1.3c.4-.8 1.4-1.5 2.8-1.5 3 0 3.6 2 3.6 4.5V23z" })
), Ge = r(De), Ie = Ge, ke = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M16 5.01c-6.2 0-11 4.53-11 10.66a10.46 10.46 0 0 0 3.45 7.9.88.88 0 0 1 .3.62l.06 2a.89.89 0 0 0 1.24.78l2.18-1a.85.85 0 0 1 .59-.05 11.8 11.8 0 0 0 3.18.42c6.2 0 11-4.54 11-10.67S22.2 5.01 16 5.01Zm6.6 8.22-3.22 5.12a1.66 1.66 0 0 1-2.39.44l-2.57-1.93a.66.66 0 0 0-.79 0l-3.48 2.63a.52.52 0 0 1-.75-.7l3.23-5.12a1.64 1.64 0 0 1 2.37-.44l2.57 1.93a.68.68 0 0 0 .8 0l3.47-2.63a.52.52 0 0 1 .76.69v.01Z" })
), be = r(ke), Ye = be, Ke = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M20.558 19.35c-1.178.748-2.796 1.046-3.867 1.153l.9.885 3.275 3.276c1.198 1.227-.753 3.149-1.965 1.965-.822-.83-2.024-2.033-3.276-3.29l-3.276 3.286c-1.212 1.183-3.163-.758-1.95-1.966.83-.831 2.024-2.034 3.275-3.276l.885-.884c-1.056-.113-2.704-.392-3.892-1.154-1.398-.905-2.014-1.433-1.471-2.533.318-.626 1.188-1.154 2.347-.244 0 0 1.56 1.241 4.077 1.241 2.518 0 4.078-1.241 4.078-1.241 1.153-.905 2.024-.382 2.346.244.528 1.1-.088 1.628-1.486 2.538Zm-10.516-8.776A5.577 5.577 0 0 1 15.615 5a5.577 5.577 0 0 1 5.574 5.574c0 3.065-2.503 5.559-5.574 5.559-3.07 0-5.573-2.494-5.573-5.56Zm2.835 0a2.743 2.743 0 0 0 2.738 2.738 2.74 2.74 0 0 0 2.738-2.738 2.742 2.742 0 0 0-2.738-2.748 2.742 2.742 0 0 0-2.738 2.748Z" })
), je = r(Ke), qe = je, Je = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M16 5C9.924 5 5 9.924 5 16c0 4.662 2.9 8.641 6.991 10.244-.095-.872-.185-2.204.039-3.154l1.289-5.466s-.331-.657-.331-1.633c0-1.53.885-2.672 1.99-2.672.936 0 1.391.704 1.391 1.55 0 .946-.601 2.356-.91 3.662-.258 1.096.55 1.99 1.628 1.99 1.955 0 3.46-2.063 3.46-5.037 0-2.634-1.892-4.477-4.594-4.477-3.128 0-4.967 2.346-4.967 4.774 0 .945.365 1.96.82 2.51.09.107.103.206.078.313-.082.348-.271 1.096-.306 1.246-.047.202-.159.245-.369.146-1.375-.64-2.234-2.647-2.234-4.262 0-3.472 2.522-6.656 7.266-6.656 3.815 0 6.78 2.72 6.78 6.355 0 3.79-2.389 6.84-5.706 6.84-1.113 0-2.162-.58-2.522-1.263l-.684 2.617c-.249.954-.92 2.153-1.366 2.883 1.031.318 2.123.49 3.257.49 6.076 0 11-4.924 11-11S22.076 5 16 5Z" })
), Qe = r(Je), Xe = Qe, We = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M11.921 24.876c8.3 0 12.84-6.878 12.84-12.841 0-.194-.003-.391-.012-.585A9.168 9.168 0 0 0 27 9.114a8.9 8.9 0 0 1-2.59.709 4.538 4.538 0 0 0 1.984-2.496 9.072 9.072 0 0 1-2.865 1.095 4.52 4.52 0 0 0-7.694 4.116 12.819 12.819 0 0 1-9.301-4.713 4.519 4.519 0 0 0 1.396 6.023 4.52 4.52 0 0 1-2.045-.563v.056a4.512 4.512 0 0 0 3.622 4.426 4.488 4.488 0 0 1-2.037.077 4.523 4.523 0 0 0 4.215 3.137A9.052 9.052 0 0 1 5 22.848a12.805 12.805 0 0 0 6.921 2.028Z" })
), e0 = r(We), t0 = e0, c0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M8.134 10H5.8c-.667 0-.8.314-.8.66 0 .618.79 3.685 3.684 7.739 1.928 2.77 4.646 4.27 7.118 4.27 1.484 0 1.667-.333 1.667-.906V19.67c0-.667.141-.8.61-.8.347 0 .94.172 2.325 1.507 1.583 1.583 1.843 2.293 2.733 2.293h2.334c.667 0 1.001-.334.808-.992-.21-.655-.966-1.607-1.968-2.735-.545-.642-1.36-1.335-1.607-1.681-.347-.445-.248-.643 0-1.039 0 0 2.843-4.005 3.14-5.365.15-.494 0-.858-.707-.858h-2.333c-.593 0-.867.314-1.016.66 0 0-1.186 2.893-2.868 4.772-.544.544-.791.718-1.088.718-.148 0-.363-.174-.363-.668v-4.624c0-.593-.172-.858-.667-.858h-3.668c-.37 0-.593.275-.593.537 0 .562.84.692.927 2.274v3.437c0 .754-.135.89-.433.89-.79 0-2.715-2.906-3.857-6.23C8.954 10.261 8.73 10 8.134 10Z"
    }
  )
), r0 = r(c0), l0 = r0, n0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.306 12.166a6.636 6.636 0 0 0-.366-.008c-4.377 0-7.928 2.974-7.928 6.645 0 .601.098 1.183.276 1.737a10.28 10.28 0 0 1-3.339-.353l-.148-.043-3.146 1.602.841-2.634-.08-.05C5.34 17.732 4 15.636 4 13.279 4 9.259 7.896 6 12.703 6c4.354 0 7.962 2.673 8.603 6.166Zm-11.631-.21c-.675 0-1.222-.531-1.222-1.184 0-.654.547-1.183 1.222-1.183.675 0 1.223.53 1.223 1.183s-.548 1.184-1.223 1.184Zm6.057-2.367c.675 0 1.222.53 1.222 1.183s-.547 1.184-1.222 1.184c-.676 0-1.221-.531-1.221-1.184 0-.654.545-1.183 1.221-1.183Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M21.006 24.996c-4.061 0-7.354-2.753-7.354-6.15 0-3.396 3.293-6.149 7.354-6.149 4.06 0 7.352 2.754 7.352 6.149 0 1.992-1.133 3.762-2.887 4.886l-.067.042.71 2.226-2.657-1.355s-.083.025-.125.036a8.644 8.644 0 0 1-2.326.315Zm-3.592-8.268c0-.551.463-1 1.032-1 .571 0 1.034.449 1.034 1 0 .553-.463 1.001-1.034 1.001-.57 0-1.032-.448-1.032-1.002Zm5.117 0c0-.551.462-1 1.032-1 .571 0 1.033.449 1.033 1 0 .553-.462 1.001-1.033 1.001-.57 0-1.032-.448-1.032-1.002Z"
    }
  )
), h0 = r(n0), a0 = h0, s0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M26.361 14.851c.834-.073 1.048-1.565.95-2.812-.258-3.299-3.036-5.796-6.716-5.312l-.151.018c-.435.05-.836.097-.926.607-.182 1.06.756.97 1.441.903.15-.015.286-.028.397-.028 2.188 0 4.422 1.793 4.372 4.374-.004.22-.051.476-.099.735-.144.79-.293 1.605.732 1.515Z" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M9.825 20.724c1.286 3.46 8.32 1.589 6.97-2.436-.405-1.202-1.775-2.126-3.612-1.94-2.154.224-4.22 2.063-3.358 4.376Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M22.04 15.414c-.25-.12-.503-.243-.748-.375.347-.89.562-2.042.003-2.688-.914-1.048-2.655-.574-4.068-.189-.555.151-1.06.289-1.444.314.631-1.902-.06-3.831-2.408-3.25-2.163.537-3.754 1.7-5.259 3.188-1.58 1.558-3.19 3.387-3.422 5.75-.27 2.743 1.479 4.12 3.168 5.062 5.035 2.807 13.101 1.255 15.775-2.438.376-.518.748-1.329.824-1.936.265-2.142-1.051-2.777-2.42-3.438Zm-1.445 3.189c.003 1.004-.506 1.867-1.013 2.435-1.386 1.552-4.306 2.568-7.224 2.378-2.525-.168-5.963-1.634-5.322-4.752.285-1.386 1.43-2.308 2.408-2.874 1.2-.694 2.348-1.049 4.055-1.187 3.122-.253 7.09.893 7.096 4Z"
    }
  ),
  /* @__PURE__ */ e.createElement("path", { d: "M24.21 12.039c.133.95-.144 1.776-.697 1.812-.692.045-.671-.328-.641-.861.01-.177.02-.373.007-.576-.035-.501-.456-1.08-.824-1.25-.265-.122-.583-.122-.879-.122-.511 0-.958 0-.958-.628 0-.648.502-.667.872-.68l.142-.007c1.602-.12 2.787.97 2.978 2.312Z" })
), m0 = r(s0), o0 = m0, v0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M23.802 8.21A10.957 10.957 0 0 0 6.558 21.427L5 27.102l5.809-1.523a10.95 10.95 0 0 0 11.32-.513A10.956 10.956 0 0 0 23.794 8.21h.01Zm-7.75 16.852c-1.63 0-3.23-.438-4.633-1.27l-.332-.197-3.457.904.92-3.359-.217-.344a9.107 9.107 0 1 1 7.714 4.266h.005Zm4.996-6.818c-.274-.137-1.62-.8-1.871-.89-.25-.092-.433-.137-.616.136s-.708.89-.867 1.073c-.159.183-.32.205-.593.069a7.464 7.464 0 0 1-2.207-1.359 8.302 8.302 0 0 1-1.523-1.895c-.16-.274-.016-.422.125-.558.142-.137.274-.321.411-.48.113-.139.205-.293.274-.457a.501.501 0 0 0-.024-.48c-.067-.136-.614-1.484-.842-2.031-.228-.547-.449-.462-.617-.47-.167-.007-.343-.01-.524-.01a1 1 0 0 0-.73.342c-.25.274-.959.937-.959 2.283 0 1.346.981 2.649 1.118 2.832.136.183 1.93 2.947 4.677 4.133.51.219 1.03.411 1.56.576.559.17 1.149.207 1.724.109.527-.08 1.62-.663 1.849-1.303.227-.64.227-1.187.16-1.301-.068-.114-.252-.182-.525-.32Z" })
), w0 = r(v0), E0 = w0, g0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M27.76 10.976s-.233-1.655-.955-2.382c-.914-.956-1.936-.96-2.405-1.017-3.356-.244-8.395-.244-8.395-.244h-.01s-5.039 0-8.395.244c-.469.056-1.49.061-2.405 1.017-.722.727-.951 2.382-.951 2.382S4 12.92 4 14.86v1.82c0 1.94.24 3.885.24 3.885s.233 1.655.95 2.381c.915.957 2.115.924 2.65 1.027 1.92.183 8.16.24 8.16.24s5.044-.01 8.4-.25c.469-.056 1.49-.06 2.405-1.017.722-.726.956-2.38.956-2.38S28 18.625 28 16.68v-1.819c0-1.94-.24-3.885-.24-3.885Zm-14.24 7.912v-6.745l6.483 3.384-6.483 3.361Z" })
), p0 = r(g0), d0 = p0, M0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "m12 5.5 1.7 3.6.4.9 1 .1 3.7.5-2.7 2.5-.7.7.2 1 .6 3.6-3.4-1.7-.8-.3-.9.4-3.4 1.7.6-3.6.2-1-.7-.7-2.7-2.5 3.7-.5 1-.1.4-.9L12 5.5M12 1 8.6 8.2 1 9.4l5.5 5.2L5.2 22l6.8-3.4 6.8 3.4-1.3-7.4L23 9.4l-7.6-1.1L12 1z" })
), i0 = r(M0), S0 = i0, z0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M12 7.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2-4.5-4.5-4.5zm0 7c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM11 2h2v4h-2zM4.16 5.636 5.576 4.22 8.403 7.05 6.99 8.464zM2 11h4v2H2zM4.222 18.425l2.828-2.829 1.414 1.415-2.828 2.828zM11 18h2v4h-2zM15.596 16.949l1.414-1.415 2.83 2.828-1.415 1.415zM18 11h4v2h-4zM15.535 6.99l2.829-2.829 1.414 1.414-2.828 2.829z" })
), x0 = r(z0), H0 = x0, R0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("circle", { cx: 3.2, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 6.4, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 9.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 14.5, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17.6, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 20.8, cy: 20.8, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 3.2, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 6.4, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 9.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 14.5, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17.6, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 20.8, cy: 16.4, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 3.2, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 6.4, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 9.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 14.5, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17.6, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 20.8, cy: 12, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 3.2, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 6.4, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 9.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 14.5, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17.6, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 20.8, cy: 7.7, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 3.2, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 6.4, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 9.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 14.5, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 17.6, cy: 3.3, r: 1.2 }),
  /* @__PURE__ */ e.createElement("circle", { cx: 20.8, cy: 3.3, r: 1.2 })
), C0 = r(R0), L0 = C0, O0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "116",
    height: "134",
    viewBox: "0 0 116 134",
    fill: "none",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M47.4704 134H63.1795V122.833H47.4704C25.2247 122.833 10.5699 110.103 10.5699 88.2167C10.5699 71.4667 19.2152 66.33 30.0745 58.8483C39.6686 52.26 50.0007 44.555 54.6397 25.125L57.2754 14.07C57.6971 12.1717 59.2786 11.1667 60.5438 11.1667C61.9143 11.1667 63.1795 12.1717 63.1795 14.2933V44.6667H73.7225V14.2933C73.7225 4.91333 67.2913 0 60.6492 0C55.694 0 49.6845 2.79166 47.6813 10.05L43.8858 24.0083C40.0903 38.19 32.0776 44.3317 23.0106 50.6967C10.4644 59.5183 0.65945 65.4367 0.0268696 87.1C-0.816571 117.808 18.2663 134 47.4704 134ZM73.8279 134H94.914V122.833H73.8279V134ZM73.8279 111.667H110.728V100.5H73.8279V111.667ZM73.8279 89.3333H116V78.1667H73.8279V89.3333ZM73.8279 67H105.457V55.8333H73.8279V67Z",
      fill: "#F8FCFF"
    }
  )
), A0 = r(O0), B0 = A0, T0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M19 15V6c0-2.2-1.8-4-4-4H9C6.8 2 5 3.8 5 6v9c0 1.9 1.3 3.5 3.1 3.9L5.9 22h2.5l2.1-3h2.9l2.1 3H18l-2.2-3.1c1.8-.4 3.2-2 3.2-3.9zm-2-9v3h-4.1V4H15c1.1 0 2 .9 2 2zM9 4h2.1v5H7V6c0-1.1.9-2 2-2zm6 13H9c-1.1 0-2-.9-2-2v-4.2h10V15c0 1.1-.9 2-2 2z" }),
  /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 13.9, r: 1.5 })
), V0 = r(T0), F0 = V0, _0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M21 13.1h-4.4L15 10l-2 4-3-6-2.6 5.1h-.5c-1 0-2-.6-2.4-1.6C4.2 10.7 4 9.9 4 9c0-2.4 1.5-4 3.8-4 .9 0 1.7.3 2.4 1 .7.6 1.3.7 1.8.7s1.1-.1 1.8-.7 1.5-1 2.4-1C18.5 5 20 6.6 20 9c0 .8-.2 1.5-.4 2.3h2.1c.2-.8.3-1.5.3-2.3 0-3.5-2.4-6-5.8-6-1.4 0-2.7.5-3.8 1.5-.2.2-.2.2-.4.2s-.2 0-.4-.2C10.5 3.5 9.2 3 7.8 3 4.4 3 2 5.5 2 9c0 1.1.2 2.2.7 3.2.7 1.6 2.3 2.7 4 2.7h1.9L10 12l3 6 2-4 .4.9h1.9c-1.3 1.5-2.9 3.1-4.9 4.9l-.4.4-.5-.5c-1.2-1.1-2.2-2.1-3.2-3.1H5.6c1.3 1.5 2.9 3 4.6 4.5L12 23l1.8-1.8c2.4-2.2 4.5-4.2 6-6.3H22v-1.8h-1z" })
), f0 = r(_0), N0 = f0, $0 = (t, c) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: c,
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M18.5 6C16.6 6 15 7.6 15 9.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5H2v2h16.7c1.9-.1 3.4-1.6 3.4-3.5C22 7.6 20.4 6 18.5 6z" }),
  /* @__PURE__ */ e.createElement("path", { d: "M14 5.5C14 3.6 12.4 2 10.5 2S7 3.6 7 5.5h2c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5S11.3 7 10.5 7H2v2h8.5C12.4 9 14 7.4 14 5.5zM15.5 15H2v2h13.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5c-.5 0-.9-.2-1.2-.6-.2-.3-.3-.6-.3-.9h-2c0 .8.2 1.5.7 2.1.7.9 1.7 1.4 2.8 1.4 1.9 0 3.5-1.6 3.5-3.5S17.4 15 15.5 15z" })
), u0 = r($0), y0 = u0;
var U0 = /* @__PURE__ */ ((t) => (t.ACCOMMODATION = "ACCOMMODATION", t.ACTIVITY = "ACTIVITY", t.ARROW_DOWN = "ARROW_DOWN", t.ARROW_LEFT = "ARROW_LEFT", t.ARROW_RIGHT = "ARROW_RIGHT", t.ARROW_UP = "ARROW_UP", t.ARROW_UP_RIGHT = "ARROW_UP_RIGHT", t.ART_CULTURE = "ART_CULTURE", t.ATTRACTION = "ATTRACTION", t.BAR = "BAR", t.BICYCLE = "BICYCLE", t.BOARDROOM = "BOARDROOM", t.BUBBLES = "BUBBLES", t.BUS = "BUS", t.CAR = "CAR", t.CHECK = "CHECK", t.CHEVRON_DOWN = "CHEVRON_DOWN", t.CHEVRON_LEFT = "CHEVRON_LEFT", t.CHEVRON_RIGHT = "CHEVRON_RIGHT", t.CHEVRON_UP = "CHEVRON_UP", t.CLASSROOM = "CLASSROOM", t.CLOCK = "CLOCK", t.CLOSE = "CLOSE", t.CLOUD = "CLOUD", t.CONTACT = "CONTACT", t.COPY = "COPY", t.DOWNLOAD = "DOWNLOAD", t.EMPLOYER = "EMPLOYER", t.EMPLOYEE = "EMPLOYEE", t.EURO = "EURO", t.EVENT = "EVENT", t.EYE = "EYE", t.FAMILY = "FAMILY", t.FERRY = "FERRY", t.FILTER = "FILTER", t.FOOD = "FOOD", t.GLOBE = "GLOBE", t.GROUP = "GROUP", t.HAMBURGER = "HAMBURGER", t.HEART = "HEART", t.HEART_FILLED = "HEART_FILLED", t.INDIVIDUAL = "INDIVIDUAL", t.INFO = "INFO", t.LGBT = "LGBT", t.LIST = "LIST", t.LOCATION = "LOCATION", t.MAP = "MAP", t.MENU = "MENU", t.MINUS = "MINUS", t.MIST = "MIST", t.NIGHT = "NIGHT", t.PLANE = "PLANE", t.PLUS = "PLUS", t.RAIN = "RAIN", t.RENTAL = "RENTAL", t.SAUNA = "SAUNA", t.SEARCH = "SEARCH", t.SHARE = "SHARE", t.SHOPPING = "SHOPPING", t.SIGHTSEEING = "SIGHTSEEING", t.SNOW = "SNOW", t.SO_ME_FACEBOOK = "SO_ME_FACEBOOK", t.SO_ME_INSTAGRAM = "SO_ME_INSTAGRAM", t.SO_ME_LINKEDIN = "SO_ME_LINKEDIN", t.SO_ME_MESSENGER = "SO_ME_MESSENGER", t.SO_ME_ODNOKLASSISKI = "SO_ME_ODNOKLASSISKI", t.SO_ME_PINTEREST = "SO_ME_PINTEREST", t.SO_ME_TWITTER = "SO_ME_TWITTER", t.SO_ME_V_KONTAKTE = "SO_ME_V_KONTAKTE", t.SO_ME_WECHAT = "SO_ME_WECHAT", t.SO_ME_WEIBO = "SO_ME_WEIBO", t.SO_ME_WHATSAPP = "SO_ME_WHATSAPP", t.SO_ME_YOUTUBE = "SO_ME_YOUTUBE", t.STAR = "STAR", t.SUN = "SUN", t.THEATER = "THEATER", t.THUMBSUP = "THUMBSUP", t.TRAIN = "TRAIN", t.WELLBEING = "WELLBEING", t.WIND = "WIND", t))(U0 || {});
const P0 = {
  ACCOMMODATION: d,
  ACTIVITY: S,
  ARROW_DOWN: H,
  ARROW_LEFT: L,
  ARROW_RIGHT: B,
  ARROW_UP: F,
  ARROW_UP_RIGHT: N,
  ART_CULTURE: y,
  ATTRACTION: Z,
  BAR: I,
  BICYCLE: Y,
  BOARDROOM: q,
  BUBBLES: X,
  BUS: t1,
  CAR: l1,
  CHECK: a1,
  CHEVRON_DOWN: o1,
  CHEVRON_LEFT: E1,
  CHEVRON_RIGHT: d1,
  CHEVRON_UP: S1,
  CLASSROOM: H1,
  CLOCK: L1,
  CLOSE: B1,
  CLOUD: F1,
  CONTACT: N1,
  COPY: y1,
  DOWNLOAD: Z1,
  EMPLOYER: I1,
  EMPLOYEE: Y1,
  EURO: q1,
  EVENT: X1,
  EYE: t2,
  FAMILY: l2,
  FERRY: a2,
  FILTER: o2,
  FOOD: E2,
  GLOBE: d2,
  GROUP: S2,
  HAMBURGER: H2,
  HEART: L2,
  HEART_FILLED: B2,
  INDIVIDUAL: F2,
  INFO: N2,
  LGBT: y2,
  LIST: Z2,
  LOCATION: I2,
  MAP: Y2,
  MENU: q2,
  MINUS: X2,
  MIST: te,
  NIGHT: le,
  PLANE: ae,
  PLUS: oe,
  RAIN: Ee,
  RENTAL: de,
  SAUNA: Se,
  SEARCH: He,
  SHARE: Le,
  SHOPPING: Be,
  SIGHTSEEING: Fe,
  SNOW: Ne,
  SO_ME_FACEBOOK: ye,
  SO_ME_INSTAGRAM: Ze,
  SO_ME_LINKEDIN: Ie,
  SO_ME_MESSENGER: Ye,
  SO_ME_ODNOKLASSISKI: qe,
  SO_ME_PINTEREST: Xe,
  SO_ME_TWITTER: t0,
  SO_ME_V_KONTAKTE: l0,
  SO_ME_WECHAT: a0,
  SO_ME_WEIBO: o0,
  SO_ME_WHATSAPP: E0,
  SO_ME_YOUTUBE: d0,
  STAR: S0,
  SUN: H0,
  THEATER: L0,
  THUMBSUP: B0,
  TRAIN: F0,
  WELLBEING: N0,
  WIND: y0
}, G0 = r(function({ icon: c, size: l, width: s, height: m, color: o, className: v, viewBox: n, ...w }, E) {
  const h = {
    ...w,
    height: m || l || 30,
    width: s || l || 30,
    fill: o,
    className: v
  };
  n && (h.viewBox = n);
  const a = P0[c];
  return a ? /* @__PURE__ */ e.createElement(a, { ...h, ref: E }) : null;
});
export {
  G0 as I,
  U0 as W
};
//# sourceMappingURL=Icon-3122c134.mjs.map
